import { createReducer } from '@reduxjs/toolkit'
import { HomeFeedAiSection } from '@/services/api'
import { setAiVideoSections, setAiVideoStatus } from './action'

export interface AiVideoState {
  sections: HomeFeedAiSection[]
  status: 'idle' | 'loading' | 'loaded' | 'error'
}

const initialState: AiVideoState = {
  sections: [],
  status: 'idle',
}

export const aiVideoReducer = createReducer(initialState, builder => {
  builder.addCase(setAiVideoSections, (state, { payload }) => {
    state.sections = payload
  })
  builder.addCase(setAiVideoStatus, (state, { payload }) => {
    state.status = payload
  })
})
